{
	"title": "Verantwoordelijkheid borgen met een carbon bank",
	"description": "Heidelberg Materials heeft grondige maatregelen genomen om de geloofwaardigheid te garanderen van de koolstofreducties die worden gerealiseerd door onze CCS-cementfabriek. Om elke mogelijkheid van dubbele boeking te voorkomen, hebben we een veilige virtuele carbon bank geïmplementeerd op een openbaar gedistribueerd grootboek.",
	"traceabilityTitle": "Traceerbaarheid van koolstofreducties"
}
